import {
    Component,
    computed,
    effect,
    ElementRef,
    inject,
    signal,
    viewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

import { LayoutFacade, LoaderType } from "@hermes/aphrodite-layout-state";
import { LoaderSpinnerComponent } from "@hermes/aphrodite-loader-spinner";

import { seedRandomImage } from "./loader.helper";
import { LoaderService } from "./loader.service";

@Component({
    selector: "h-loader",
    imports: [LoaderSpinnerComponent],
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent {
    private readonly domSanitizer = inject(DomSanitizer);
    private readonly loaderService = inject(LoaderService);
    private readonly layoutFacade = inject(LayoutFacade);
    private readonly imageSeed = signal(seedRandomImage());

    public readonly loaderTypes = LoaderType;
    public readonly loaderType = this.layoutFacade.selectLoaderType;
    public readonly loaderShown = this.layoutFacade.selectLoaderState;
    public readonly loaderImageUrl = computed(() =>
        this.domSanitizer.bypassSecurityTrustStyle(
            `url('${this.loaderService.getLoaderImageUrl(this.imageSeed())}')`,
        ),
    );

    // Get the overlay to handle focus (aria read on show)
    public readonly overlay = viewChild<ElementRef<HTMLDivElement>>("overlay");

    constructor() {
        // Change random image at every loader show
        effect(() => {
            if (
                !this.loaderShown() ||
                this.loaderType() !== LoaderType.LOADER_TYPE_IMAGE
            ) {
                return;
            }

            this.imageSeed.set(seedRandomImage());
        });

        // Accessibility: Focus the loader when shown (to read aria)
        effect(() => {
            if (!this.loaderShown()) {
                return;
            }

            const overlay = this.overlay();

            if (!overlay) {
                return;
            }

            overlay.nativeElement.focus({ preventScroll: true });
        });
    }
}
